import {AnyAction} from "redux";
import {CLEAR_SELECTED_LOCATION, SET_HIGHLIGHT_LOCATION, SET_SELECTED_LOCATION} from "./action";


/**
 * set the selected location
 * @param location_id
 * @return {{type: string, payload: {location_id: number}}}
 */
export function setSelectedLocation(location_id: number) : AnyAction
{
    return {type: SET_SELECTED_LOCATION, payload: {location_id}};
}


/**
 * set the selected location
 * @param location_id
 * @return {{type: string, payload: {location_id: number}}}
 */
export function setHighlightLocation(location_id: number = null) : AnyAction
{
    return {type: SET_HIGHLIGHT_LOCATION, payload: {location_id}};
}


/**
 * clear the selected location
 * @return {{type: string, payload: {}}}
 */
export function clearSelectedLocation() : AnyAction
{
    return {type: CLEAR_SELECTED_LOCATION};
}


// WEBPACK FOOTER //
// ./src/ts/store/actions/locations.ts